const translations = {
    save: 'Save Aircraft',
    saveError: 'Something went wrong. Please try again.',
    title: 'Edit Aircraft'
};

export default translations;
